import * as React from "react";
import Component from "src/components/Component";
import withAxios, { IAxiosProps } from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import IDirectorPageProps from "../IDirectorPageProps";
import Page from "src/components/Page";
import EvaluationPrinter, { PrintEvaluationFunc } from "../evaluation/EvaluationPrinter";
import GenerateReportModal from "../dashboard/reportGeneratemodal";
import VideoModal from "src/components/videoModal";
import "./report-history.css";
import { FILE_URL } from "src/constants";




interface IReport {
  id: number | string;
  chatgptChangeResposne: Record<string, any>;
  [key: string]: any;
}

// Extend props to include schoolData and editableReportData
interface IReportHistoryProps extends IAxiosProps, IDirectorPageProps {
  schoolData: {
    ismidseason: boolean;
    name?: string;
    logo1?: string;
    primaryColor?: string;
    [key: string]: any;
  };
  refreshReports: () => void;
  editableReportData: IReport[];
}

interface IState {
  loading: boolean;
  error?: string;
  viewMode: "school" | "coach";
  sportId: string;
  coachId: string;
  type: string;
  year: string;
  season: string;
  data: any;
  coachList: any[];
  coachListLoading: boolean;
  showPrintButton?: boolean;
  reportGenerateModalVisible?: boolean;
  validationErrors: {
    viewMode?: string;
    season?: string;
    coach?: string;
    year?: string;
    data?: string;
  };
  showVideo: boolean;
  videoURL: string;
  openSchoolPopup: boolean;
  openCoachPopup: boolean;
  selectedSurveyId?: number;
  editableReportData: IReport[];
  coachIds: any[]; // For multi-select coach IDs
  dropdownOpen: boolean;
}


// Exact request payload shape for /reports/reportGetAllData
interface IReportGetAllDataRequest {
  schoolId: number;           // e.g., 91
  sessionType: string;        // e.g., "FALL"
  coachId: number;            // e.g., 1133
  type: "coach";             // literal value "coach"
  year: string;               // e.g., "2023"
}

export default withSchoolContext(
  withAxios(
    class ReportHistory extends Component<IReportHistoryProps & IAxiosProps & IDirectorPageProps, IState> {
      public readonly state = this.buildState({
        loading: false,
        viewMode: "school",
        year: String(new Date().getFullYear()),
        type: "",
        sportId: "",
        coachId: "",
        season: "",
        data: null,
        coachList: [],
        coachListLoading: false,
        validationErrors: {},
        showVideo: false,
        videoURL: "",
        openSchoolPopup: false,
        openCoachPopup: false,
        selectedSurveyId: undefined,
        editableReportData: [],
        coachIds: [],  // Corrected typo here
        dropdownOpen: false
      });

      private printEvaluation?: PrintEvaluationFunc;
      public readonly setPrintEvaluation = (
        printEvaluation: PrintEvaluationFunc | null
      ) => {
        this.printEvaluation = printEvaluation === null ? undefined : printEvaluation;
        this.setState({ showPrintButton: !!this.printEvaluation });
      };
      public readonly handleVideoClick = (videoURL: string) => {
        this.setState({ showVideo: true, videoURL });
      };

      public readonly handleSchoolViewPrintClick = async () => {
        const { year, season } = this.state;
        const validationErrors: { year?: string; season?: string } = {};

        if (!year) {
          validationErrors.year = "Please select a year";
        }

        if (!season) {
          validationErrors.season = "Please select a season";
        }

        if (Object.keys(validationErrors).length > 0) {
          this.setState({ validationErrors });
          return;
        }

        this.setState({ openSchoolPopup: true });
        try {
          this.setState({ loading: true, error: undefined });
          const schoolId = Number(this.props.school?.id);
          if (!schoolId) {
            this.setState({ loading: false, error: "Invalid school id" });
            return;
          }

          const payload = {
            schoolId,
            sportId: -1,
            coachId: -1,
            type: "ad",
            sessionType: this.state.season,
            year: this.state.year,
          } as const;

          const response: any = await this.buildPost<any, any>(this, "/reports/reportGetAll")(payload);
          const rawData = response?.data;
          console.log("school view print response", response);
          console.log("rawData:", rawData);
          console.log("rawData type:", typeof rawData);
          console.log("rawData isArray:", Array.isArray(rawData));

          const hasData = !!rawData && (
            (Array.isArray(rawData) && rawData.length > 0) ||
            (!Array.isArray(rawData) && Object.keys(rawData).length > 0)
          );

          if (hasData) {
            // Normalize to array for editing/rendering convenience
            const normalizedArray = Array.isArray(rawData)
              ? rawData
              : (rawData?.data && Array.isArray(rawData.data))
                ? rawData.data
                : [rawData];
            console.log("normalizedArray:", normalizedArray);
            console.log("normalizedArray length:", normalizedArray.length);
            this.setState({ data: rawData, editableReportData: normalizedArray, loading: false, reportGenerateModalVisible: true });
          } else {
            // Keep modal open and show message inside the popup
            this.setState({ data: [], loading: false });
            alert("No report found for the selected year and season.");

          }
        } catch (err: any) {
          this.setState({ loading: false, error: err?.message || "Failed to load school reports" });
        }
      };




      

      public readonly handlePrintClick = async (coachIdParam?: string | number) => {
        try {
          const { school } = this.props;
          const { season, year } = this.state;

          const coachId = coachIdParam ?? this.state.coachId; // Use parameter if provided, fallback to state

          // Clear previous validation errors
          this.setState({ validationErrors: {} });

          // Validation
          if (!season || season.trim() === "") {
            this.setState({ validationErrors: { season: "Please select a season first" } });
            return;
          }
          if (!coachId || String(coachId).trim() === "") {
            this.setState({ validationErrors: { coach: "Please select a coach first" } });
            return;
          }
          if (!year || year.trim() === "") {
            this.setState({ validationErrors: { year: "Please select a year first" } });
            return;
          }

          const coachIdNum = Number(coachId);

          // Fetch reports
          await this.fetchReportsCoach(coachIdNum);

          // Check if data exists
          if (!this.state.data || (Array.isArray(this.state.data) && this.state.data.length === 0)) {
            alert("No report found for the selected year and season.");
            return;
          }

          // Get surveyId
          let surveyId: number | undefined;

          if (Array.isArray(this.state.data) && this.state.data.length > 0) {
            const firstReport = this.state.data[0];
            surveyId = firstReport?.surveyId || firstReport?.survey_id;
          } else if (this.state.data?.data && Array.isArray(this.state.data.data)) {
            const firstReport = this.state.data.data[0];
            surveyId = firstReport?.surveyId || firstReport?.surveyId[0];
          }

          if (!surveyId) {
            alert("No survey ID found in report data");
            return;
          }

          
          if (this.printEvaluation && school && coachIdNum && surveyId) {
            await this.printEvaluation(school, surveyId, coachIdNum); // <- await here
          } else {
            console.log("Falling back to window.print()");
          }
        } catch (err) {
          console.error("Print evaluation failed:", err);
        }
      };


      public handleCoachCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;

        console.log("Checkbox change:", { value, checked });
        let updatedCoachIds = [...this.state.coachIds];



        if (checked) {
          // Add coach ID
          updatedCoachIds.push(value);
        } else {
          // Remove coach ID
          updatedCoachIds = updatedCoachIds.filter((id) => id !== value);
        }
        console.log(updatedCoachIds, "updatedCoachIds")

        this.setState(
          { coachIds: updatedCoachIds, validationErrors: {} }
          // ,this.fetchCoachList
        );
      };

      public componentDidMount() {
        // this.fetchCoachList();
        // Automatically check and play video when page loads
        this.checkAndPlayVideo();
      }



      public render() {
        const { loading, error, data, year, coachId, season, viewMode, coachList, coachListLoading, reportGenerateModalVisible } = this.state;
        const { coaches, seasons, school } = this.props as any;
        // Use fetched coach list for coach mode, fallback to props coaches
        const availableCoaches = viewMode === "coach" ? coachList : coaches;
        const selectedCoach = (availableCoaches as Array<{ id: number; name: string }>).find((c: { id: number; name: string }) => String(c.id) === String(coachId));
        const reportArray = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);

        return (
          <Page header={"Report History"} subtitle={"Filter and view previous reports"}>
            <EvaluationPrinter printEvaluationRef={this.setPrintEvaluation} />
            <div className="report-history-outer-container">
              <div className="report-history-inner-container">
                {/* View mode selector */}
                <div>
                  <select className="select-style"
                    value={viewMode}
                    onChange={(e) => this.setState({ viewMode: e.target.value as any, validationErrors: {} })}

                  >
                    <option value="school">By School</option>
                    <option value="coach">By Coach</option>
                  </select>
                  {this.state.validationErrors.viewMode && (
                    <div className="error">
                      {this.state.validationErrors.viewMode}
                    </div>
                  )}
                </div>

                {/* Year for school mode; Season for coach mode */}
                {viewMode === "school" ? (
                  <>
                    <div>
                      <select className="select-style"
                        value={year}
                        onChange={(e) => this.setState({ year: e.target.value, validationErrors: {} })}

                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Year
                        </option>
                        {Array.from({ length: 4 }).map((_, i) => {
                          const y = String(new Date().getFullYear() - i);
                          return (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          );
                        })}
                      </select>
                     
                      {this.state.validationErrors.year && (
                        <div className="error">
                          {this.state.validationErrors.year}
                        </div>
                      )}
                    </div>

                    <div>
                      <select className="select-style"
                        value={season}
                        onChange={(e) => this.setState({ season: e.target.value, coachIds: [], validationErrors: {} }, this.fetchCoachList)}

                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Season
                        </option>
                        {seasons.map((s: { name: string }) => (
                          <option key={s.name} value={s.name}>
                            {s.name}
                          </option>
                        ))}
                      </select>
                      {this.state.validationErrors.season && (
                        <div className="error">
                          {this.state.validationErrors.season}
                        </div>
                      )}
                    </div>

                    {/* Show selected Year + Season summary under selects */}

                    <div>
                      <button
                        className="upgrade-subscription-btn"
                        onClick={this.handleSchoolViewPrintClick}
                        disabled={loading}

                        title="View & Print by School"
                      >
                        <span>{loading ? "Loading..." : "View & Print"}</span>
                      </button>
                    </div>

                  </>
                ) : (
                  <div>
                    <select className="select-style"
                      value={season}
                      onChange={(e) => this.setState({ season: e.target.value, coachIds: [], validationErrors: {} }, this.fetchCoachList)}

                    >
                      <option value="" disabled={true} hidden={true}>
                        Select Season
                      </option>
                      {seasons.map((s: { name: string }) => (
                        <option key={s.name} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                    {this.state.validationErrors.season && (
                      <div className="error">
                        {this.state.validationErrors.season}
                      </div>
                    )}
                  </div>
                )}


                {/* Coach for coach mode */}
                {viewMode === "coach" ? (
                  <>
                    <div>
                      <select className="select-style"
                        value={year}
                        onChange={(e) => this.setState({ year: e.target.value, coachIds: [], validationErrors: {} }, this.fetchCoachList)}
                      // onChange={(e) => this.setState({ coachId: e.target.value, validationErrors: {} }, this.fetchCoachList)}
                      // coachIds: []
                      >
                        <option value="" disabled={true} hidden={true}>
                          Select Year
                        </option>
                        {Array.from({ length: 4 }).map((_, i) => {
                          const y = String(new Date().getFullYear() - i);
                          return (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          );
                        })}
                      </select>

                      {this.state.validationErrors.year && (
                        <div className="error">
                          {this.state.validationErrors.year}
                        </div>
                      )}
                    </div>
                    

                    <div className="select-coach-outer">
                      {/* Dropdown header */}
                      <div className="select-coach"
                        onClick={() =>
                          this.setState({ dropdownOpen: !this.state.dropdownOpen })
                        }
                        
                      >
                        {this.state.coachIds.length > 0
                          ? `${this.state.coachIds.length} coach(es) selected`
                          : "Select Coach"}
                      </div>

                      {/* Dropdown list */}
                      <div className="select-coach-child">
                        {coachListLoading ? (
                          <p style={{ padding: "10px", margin: 0 }}>Loading coaches...</p>
                        ) : (
                          (availableCoaches as Array<{ id: number; name: string }>).map(
                            (coach) => (
                              <label
                                key={coach.id}
                                style={{
                                  display: "block",
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value={String(coach.id)}
                                  checked={this.state.coachIds.includes(String(coach.id))}
                                  onChange={this.handleCoachCheckboxChange}
                                  disabled={coachListLoading}
                                  style={{ marginRight: "8px" }}
                                />
                                {coach.name}
                              </label>
                            )
                          )
                        )}
                      </div>

                      {/* Error */}
                      {this.state.validationErrors.coach && (
                        <div style={{ color: "red", marginTop: "4px", fontSize: "12px" }}>
                          {this.state.validationErrors.coach}
                        </div>
                      )}
                    </div>


                    <button
                      className="upgrade-subscription-btn"
                      onClick={async () => {
                        const { coachIds } = this.state;
                        console.log("Selected coachIds for printing:", coachIds);

                        if (!coachIds || coachIds.length === 0) {
                          alert("Select at least one coach first");
                          return;
                        }

                        // Small helper for delay
                        // const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

                        // Loop through each coach and open print tab
                        coachIds.forEach((id, index) => {
                          (async (coachIdClosure) => {
                            await this.handlePrintClick(coachIdClosure);
                            // await sleep(500); // optional 0.5s delay between tabs
                          })(id);
                        });
                      }}
                      disabled={this.state.loading}
                      title={
                        !this.state.coachIds || this.state.coachIds.length === 0
                          ? "Select at least one coach first"
                          : (!this.state.data || this.state.data.length === 0)
                            ? "No report data available"
                            : "Print report"
                      }
                    >
                      <span>View & Print</span>
                    </button>




                  </>
                ) :

                  (
                    <div />
                  )}






                <div>

                  {this.state.validationErrors.data && (
                    <div className="error">
                      {this.state.validationErrors.data}
                    </div>
                  )}
                </div>







              </div>



              {error && <div style={{ color: "#b00020" }}>{error}</div>}


            </div>

            {(() => {
              console.log("Modal render check:", { reportGenerateModalVisible, selectedCoach, reportArray, data });
              console.log("reportArray length:", reportArray?.length);
              console.log("data structure:", data);
              return reportGenerateModalVisible && (
                <GenerateReportModal
                  open={true}
                  closeModal={() => this.setState({ reportGenerateModalVisible: false })}
                  ReportData={reportArray}
                  schoolData={school}
                  schoolId={school?.id}
                  slug={school?.slug}
                  refreshReports={this.fetchReports}
                  readOnly={true}
                  key={`modal-${reportArray?.length || 0}`} // Force re-render when data changes
                />
              );
            })()}


            {/* Video Modal */}
            <VideoModal
              videoURL={FILE_URL + "/" + this.state.videoURL}
              // videoURL={this.state.videoURL}
              open={this.state.showVideo}
              handleClose={async () => {
                this.setState({ showVideo: false });
                // Report video watched when modal is closed
                try {
                  const userResponse: any = await this.buildGet<any>(this, "user")();
                  const userId = String(userResponse?.data?.id || userResponse?.id || "1");
                  const schoolId = String(this.props.school?.id || "1");
                  await this.reportVideoWatched(userId, schoolId);
                } catch (err) {
                  console.error("Error getting user ID for video report:", err);
                }
              }}
            />
          </Page>

        );
      }
      private readonly fetchReportsCoach = async (coachIdNum: number) => {
        this.setState({ loading: true, error: undefined });
        console.log("Fetching reports with state:", this.state);
        console.log("Fetching reports with props:", this.props);
      
        try {
          const payload: IReportGetAllDataRequest = {
            schoolId: Number(this.props.school.id),
            sessionType: String(this.state.season || ""),
            coachId: coachIdNum, // use the passed parameter here
            type: "coach",
            year: String(this.state.year),
          };
      
          const ReportData: any = await this.buildPost<
            IReportGetAllDataRequest,
            any
          >(this, "/reports/reportGetAllData")(payload);
      
          this.setState({ data: ReportData?.data ?? ReportData, loading: false });
        } catch (err: any) {
          this.setState({ error: err?.message || "Failed to load reports", loading: false });
        }
      };
      

      private readonly fetchReports = async () => {
        this.setState({ loading: true, error: undefined });
        console.log("Fetching reports with state:", this.state);
        console.log("Fetching reports with props:", this.props);

        try {
          const payload: IReportGetAllDataRequest = {
            schoolId: Number(this.props.school.id),
            sessionType: String(this.state.season || ""),
            coachId: Number(this.state.coachId || 0),
            type: "coach",
            year: String(this.state.year),
          };

          const ReportData: any = await this.buildPost<
            IReportGetAllDataRequest,
            any
          >(this, "/reports/reportGetAllData")(payload);

          this.setState({ data: ReportData?.data ?? ReportData, loading: false });
        } catch (err: any) {
          this.setState({ error: err?.message || "Failed to load reports", loading: false });
        }
      };

      private readonly fetchCoachList = async () => {
        this.setState({ coachListLoading: true });
        try {
          const sessionType = this.state.season ? encodeURIComponent(this.state.season) : "";
          const coachListUrl = sessionType
            ? `/report/coachlist/${this.props.school.id}?sessionType=${sessionType}&year=${this.state.year}`
            : `/report/coachlist/${this.props.school.id}`;
          const response = await this.buildGet<any>(this, coachListUrl)();
          this.setState({
            coachList: response?.data || response || [],
            coachListLoading: false
          });
        } catch (err: any) {
          console.error("Failed to fetch coach list:", err);
          this.setState({
            coachList: [],
            coachListLoading: false
          });
        }
      };

      private readonly checkAndPlayVideo = async () => {
        try {
          const { school } = this.props;
          // Get actual user ID from API
          const userResponse: any = await this.buildGet<any>(this, "user")();
          const userId = String(userResponse?.data?.id || userResponse?.id || "1");

          const schoolId = String(school?.id); // Get actual school ID from props

          console.log("Using userId:", userId, "and schoolId:", schoolId);

          // Check if video should be shown via API
          // const videoCheckResponse = await this.buildGet<any>(this, `/report/getVideo/${userId}/${schoolId}`)();
          const videoCheckResponse = await this.buildGet<any>(this, `/report/getVideo/${schoolId}/${userId}`)();

          console.log("Video check response:", videoCheckResponse);

          if (videoCheckResponse.status === true) {
            console.log("testing purpose", videoCheckResponse.status)
          }
          if (videoCheckResponse.status === true || videoCheckResponse?.data.status === true) {
            console.log("Video should be shown, opening video modal", videoCheckResponse.status);


            // Get the actual video URL using the video ID from response
            const videoId = 5;
            await this.getVideoURL(videoId);

            // After video is shown, call the report API
            // await this.reportVideoWatched(userId, schoolId);
          } else {
            console.log("Video should not be shown");
          }
        } catch (err) {
          console.error("Error checking for video :", err);
        }
      };

      private readonly reportVideoWatched = async (userId: string, schoolId: string) => {
        try {
          const payload = {
            userId,
            schoolId
          };

          const response = await this.buildPost<any, any>(this, "/report/reportVideoCreate")(payload);
          console.log("Video watched reported successfully:", response);
        } catch (err) {
          console.error("Error reporting video watched:", err);
        }
      };

      private readonly getVideoURL = async (videoId: any) => {
        try {
          const res: any = await this.buildGet(this, "video/getOneVideo/" + videoId)();

          console.log("Video response:", res);

          if (res?.data?.file) {
            const videoURL = res.data.file;
            this.setState({ showVideo: true, videoURL });
            console.log("Video URL set:", videoURL);
          } else {
            console.log("No video file found in response");
          }
        } catch (err) {
          console.error("Error getting video URL:", err);
        }
      };
    }
  )
);




// WEBPACK FOOTER //
// ./src/pages/director/reportHistory/index.tsx